export const cruisesLineDe = [
  {
    text: "A-ROSA",
    value: "11253",
  },
  {
    text: "AIDA Cruises",
    value: "11247",
  },
  {
    text: "Allure Active",
    value: "11359",
  },
  {
    text: "American Queen Steamboat Comp.",
    value: "11306",
  },
  {
    text: "Atlas River Cruising ",
    value: "14813",
  },
  {
    text: "Azamara ",
    value: "11323",
  },
  {
    text: "Carnival",
    value: "11248",
  },
  {
    text: "Celebrity Cruises",
    value: "11246",
  },
  {
    text: "Chervona Ruta",
    value: "11268",
  },
  {
    text: "Classica River Cruises",
    value: "14692",
  },
  {
    text: "Color Line",
    value: "11310",
  },
  {
    text: "Costa Kreuzfahrten",
    value: "11250",
  },
  {
    text: "CroisiEurope",
    value: "14814",
  },
  {
    text: "Cruiselines Nijmegen",
    value: "11338",
  },
  {
    text: "Crystal Cruises",
    value: "11252",
  },
  {
    text: "Cunard",
    value: "11255",
  },
  {
    text: "DCS-Touristik",
    value: "11331",
  },
  {
    text: "Disney",
    value: "11304",
  },
  {
    text: "DouroAzul",
    value: "11339",
  },
  {
    text: "Dunav Tours",
    value: "11266",
  },
  {
    text: "Dutch Cruise Line",
    value: "11353",
  },
  {
    text: "florentina-boat",
    value: "11329",
  },
  {
    text: "FTI Cruises",
    value: "11362",
  },
  {
    text: "Girolibero",
    value: "11351",
  },
  {
    text: "Goldberg Ventures",
    value: "11350",
  },
  {
    text: "Hapag-Lloyd Cruises",
    value: "11269",
  },
  {
    text: "Holland America Line",
    value: "11261",
  },
  {
    text: "Hurtigruten",
    value: "11251",
  },
  {
    text: "Königstein River Cruises",
    value: "11314",
  },
  {
    text: "KVS",
    value: "11337",
  },
  {
    text: "Lüftner Cruises",
    value: "11267",
  },
  {
    text: "Luther Travel Cruises",
    value: "14693",
  },
  {
    text: "Majestic International Cruises",
    value: "11375",
  },
  {
    text: "Marine Cruise",
    value: "11298",
  },
  {
    text: "MSC Cruise",
    value: "15663",
  },
  {
    text: "Mystic Cruises",
    value: "14884",
  },
  {
    text: "nicko cruises",
    value: "11290",
  },
  {
    text: "Norwegian Cruise Line",
    value: "11265",
  },
  {
    text: "Oceania Cruises",
    value: "11284",
  },
  {
    text: "P&O",
    value: "15649",
  },
  {
    text: "Patria Cruises",
    value: "11328",
  },
  {
    text: "Paul Gauguin Cruises",
    value: "11263",
  },
  {
    text: "Phoenix",
    value: "11270",
  },
  {
    text: "PLANTOURS",
    value: "11360",
  },
  {
    text: "PONANT",
    value: "11307",
  },
  {
    text: "Premicon AG",
    value: "11286",
  },
  {
    text: "Princess Cruises",
    value: "11271",
  },
  {
    text: "Princess River",
    value: "11297",
  },
  {
    text: "Pullmantur Cruises",
    value: "15644",
  },
  {
    text: "Regent Seven Seas",
    value: "11262",
  },
  {
    text: "River Cruises Holding B.V.",
    value: "15115",
  },
  {
    text: "River Tours",
    value: "11288",
  },
  {
    text: "Riverman Cruises GmbH",
    value: "15583",
  },
  {
    text: "Rivertech",
    value: "11394",
  },
  {
    text: "Royal Caribbean",
    value: "11260",
  },
  {
    text: "Sail & Cruises",
    value: "11299",
  },
  {
    text: "SANS SOUCI (Reed.)",
    value: "11325",
  },
  {
    text: "Scenic Tours",
    value: "11389",
  },
  {
    text: "Scylla AG",
    value: "15474",
  },
  {
    text: "SE-Tours GmbH",
    value: "14418",
  },
  {
    text: "Sea Cloud Cruises",
    value: "11277",
  },
  {
    text: "Seabourn",
    value: "11333",
  },
  {
    text: "Select Voyages",
    value: "11289",
  },
  {
    text: "Silversea",
    value: "11257",
  },
  {
    text: "Star Clippers",
    value: "11272",
  },
  {
    text: "TransOcean Kreuzfahrten",
    value: "14968",
  },
  {
    text: "TUI Cruises",
    value: "11343",
  },
  {
    text: "WT Cruises",
    value: "11301",
  },
];
